import { render } from "./TransactionsTable.vue?vue&type=template&id=a31008fa&scoped=true"
import script from "./TransactionsTable.vue?vue&type=script&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&lang=js"

import "./TransactionsTable.vue?vue&type=style&index=0&id=a31008fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31008fa"]])

export default __exports__